module.exports = __webpack_public_path__ + "img/gysgl.2e782114.png";